import React from "react";

const TeacherEducation = ({teacher}) => {
    teacher.education?.sort((a, b) => b.year - a.year);

    return (
        <div>
            <p className="sub-menu-header"></p>
            <div className="teacher-edu-details">
                {
                    teacher.education?.map((ed) => (
                        <div className="teacher-data-item nw-flex-h flex-no-wrap" style={{marginBottom: '2em'}} >
                            <div className="nw-unit" style={{minWidth: '100px'}}>
                                <h2 style={{fontWeight: 300}}>{ed.year}</h2>
                            </div>
                            <div className="nw-unit nw-unit-grow">
                                <h2>{ed.degree}</h2>
                                <h4>{ed.institution}</h4>
                                {ed.remarks && <p className="edu-remarks">{ed.remarks}</p>}
                            </div>
                        </div>
                        
                    ))
                }
            </div>

            <p className="last-updated-on">Last updated on {teacher.education_last_updated_on}</p>
        </div>
    );
};

export default TeacherEducation;
